import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import IProduct, { IProductInput } from "@/interfaces/product.interface";
import productService from "@/services/product.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateProductProps = {
  formData: IProductInput;
} & RequestsProps;

export type UseCreateProductReturn = {
  create: (props: CreateProductProps) => Promise<IProduct>;
} & UseLoadingReturn;

const useCreateProduct = (): UseCreateProductReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<IProductInput>({
    operation: (formData) => productService.create(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useCreateProduct;
